import React from 'react';
import { Container } from 'react-bootstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfo } from '@fortawesome/free-solid-svg-icons';

import './SentVerificationEmailNotificationPage.css';

const SentVerificationEmailNotificationPage = () => {
  return (
    <div className="sent-verification-email-notification-page">
    <Container>
      {/* Page Title */}
      <h2>
        <FontAwesomeIcon className="page-title-icon" icon={faInfo} />
        <span className="page-title">We Sent You Email With Verification Link!</span>
      </h2>
      {/* End Page Title */}
      {/* Page Content */}
      <div>Check your email, please, and confirm your email address by click on the link, we have sent you.</div>
      {/* End Page Content */}
    </Container>
  </div>  
  );
};

export default SentVerificationEmailNotificationPage;